import { required } from "vuelidate/lib/validators";

export default class ClienteData {
  nome = "";

  nome_empresa = "";

  email = "";

  fone = "";

  id_plan = null;

  parceiro_revenda = false;

  licenca_parceiro = null;

  password = null;

  revenda = false;

  constructor({
    nome = "",
    nome_empresa = "",
    email = "",
    fone = "",
    id_plan = null,
    parceiro_revenda = false,
    licenca_parceiro = null,
    password = null,
    revenda = false,
  }) {
    this.nome = nome;
    this.nome_empresa = nome_empresa;
    this.email = email;
    this.fone = fone;
    this.id_plan = id_plan;
    this.parceiro_revenda = parceiro_revenda;
    this.licenca_parceiro = licenca_parceiro;
    this.password = password;
    this.revenda = revenda;
  }
}

export const ClienteDataRequired = {
  nome: {
    required,
  },
  password: {
    required,
  },
  nome_empresa: {
    required,
  },
  email: {
    required,
  },
  fone: {
    required,
  },
};
